const getGlobalStyles = () => ({
  html: {
    height: "100%",
    width: "100%",
  },

  body: {
    fontFamily:
      '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    height: "100%",
    width: "100%",
    margin: "0%",
  },

  "#root": {
    height: "100%",
  },

  ":root": {
    "--color-hex": "#1E1E1E",
    "--brand": "#1e3f66",
    "--brand-muted": "rgba(30, 63, 102, 0.08)",
    "--text-primary": "#1a1d21",
    "--text-secondary": "#5c6370",
    "--text-muted": "#8b929e",
    "--border": "#e4e7ec",
    "--surface": "#ffffff",
    "--radius": "12px",
    "--grid-break": "640px",
    "--page-max-width": "80rem",
  },
});

export default getGlobalStyles;
